"use client";

import {cssTransition} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const FadeTransition = cssTransition({
  enter: "animate-toast-fade-in",
  exit: "animate-toast-fade-out",
  appendPosition: false,
  collapse: true,
  collapseDuration: 200,
});


export const ToastIcons = {
  success: <i className="fa-duotone fa-light fa-circle-check text-green-200 text-lg" />,
  error: <i className="fa-duotone fa-light fa-circle-xmark text-red-200 text-lg" />,
  info: <i className="fa-duotone fa-light fa-circle-info text-blue-200 text-lg" />,
  warning: <i className="fa-duotone fa-light fa-triangle-exclamation text-amber-200 text-lg" />,
};

